module.exports = __webpack_public_path__ + "img/station-icon_6.24fd83aa.png";